import React from "react";
import {
  ParagraphCopy,
  ParagraphAudio,
  ParagraphVideo,
  ParagraphImage,
  Maybe,
  FieldNodeHeritageSiteFieldContent,
  FieldNodeEventFieldContent
} from "../../generated/graphql";
import FieldCopy from "./FieldCopy";
import ReactPlayer from "react-player";
import styled from "styled-components";

export type ParagraphType =
  | (Maybe<FieldNodeHeritageSiteFieldContent>[] &
    Maybe<FieldNodeEventFieldContent>[])
  | null
  | undefined;

const ParagraphWrapper: React.FC<{ pageContent: ParagraphType }> = props => {
  return (
    <>
      {props.pageContent &&
        props.pageContent.map((content, i) => {
          const typedContent = content?.entity as ParagraphCopy &
            ParagraphAudio &
            ParagraphVideo &
            ParagraphImage;

          switch (typedContent?.__typename!) {
            case "ParagraphCopy":
              return (
                <Wrapper key={i}>
                  <FieldCopy htmlString={typedContent.fieldCopy?.value} />
                </Wrapper>
              );
            case "ParagraphAudio":
              return (
                typedContent.fieldAudioUrl && (
                  <Wrapper key={i}>
                    <ResponsivePlayer>
                      <ReactPlayer
                        className="react-player"
                        url={typedContent.fieldAudioUrl}
                        width="100%"
                        height="100%"
                      />
                    </ResponsivePlayer>
                  </Wrapper>
                )
              );
            case "ParagraphImage":
              return (
                typedContent.fieldImage?.url && (
                  <Wrapper key={i}>
                    <HeaderMedia>
                      <img
                        src={typedContent.fieldImage?.url}
                        alt={typedContent.fieldImage.alt || ""}
                      />
                    </HeaderMedia>
                  </Wrapper>
                )
              );
            case "ParagraphVideo":
              return (
                typedContent.fieldVideoUrl && (
                  <Wrapper key={i}>
                    <ResponsivePlayer>
                      <ReactPlayer
                        className="react-player"
                        url={typedContent.fieldVideoUrl}
                        width="100%"
                        height="100%"
                      />
                    </ResponsivePlayer>
                  </Wrapper>
                )
              );

            default:
              break;
          }
          return null;
        })}
    </>
  );
};

const Wrapper = styled.div`
  padding: 1rem 0;
`;

const HeaderMedia = styled.div`
  width: 100%;
  height: 540px;
  display: flex;
  img {
    width: 100%;
    object-fit: cover;
  }
`;

const ResponsivePlayer = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default ParagraphWrapper;
